package com.devi3east.bashbuddy.account.organization.requests

import com.devi3east.bashbuddy.common.domain.models.Address
import kotlinx.serialization.Serializable

@Serializable
data class UpdateOrganizationRequest(
    val organizationName: String,
    val organizationBio: String? = null,
    val contactPerson: String,
    val phone: String,
    val address: Address?,
    val isActive: Boolean? = null,
    val showFirstEventCreatedDialog: Boolean? = null
)